// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'
import '@/assets/css/common.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import '@/assets/icon/font/flaticon.css'
//import VueCurrencyFilter from 'vue-currency-filter'
//window.Vue = Vue
//import '@/assets/css/rangePrice.scss'
//require('@/assets/js/range.js')
/*
//import Highcharts from "highcharts";
//import Highcharts3d from "highcharts/highcharts-3d";
//import HighchartsVue from 'highcharts-vue'

// biểu đồ chart
//Highcharts3d(Highcharts);
//Vue.use(HighchartsVue)

//Vue.config.productionTip = false
Vue.use(VueCurrencyFilter,
	{
	  symbol : '',
	  thousandsSeparator: '.',
	  fractionCount: 0,
	  fractionSeparator: ',',
	  symbolPosition: 'front',
	  symbolSpacing: true
	})
	*/

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	components: { App },
	template: '<App/>'
})

